export function GEOSchema({
  type,
  data,
}: {
  type: "SoftwareApplication" | "FAQPage" | "Article" | "Product";
  data: any;
}) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": type,
          ...data,
        }),
      }}
    />
  );
}
